import { cn } from '@/shared/lib/utils';
import { companyInitials } from '@/shared/utils/activeCompany';

type CompanyInitialsBadgeProps = {
  name: string;
  className?: string;
};

const CompanyInitialsBadge = ({ name, className }: CompanyInitialsBadgeProps) => (
  <span
    aria-hidden="true"
    className={cn(
      'h-nav-avatar w-nav-avatar flex-shrink-0 rounded-md',
      'flex items-center justify-center',
      'bg-primary text-xs font-semibold text-primary-foreground',
      className,
    )}
  >
    {companyInitials(name)}
  </span>
);

export default CompanyInitialsBadge;
